import { IFulfillment } from '../../../../../features/reports/learning/common/interfaces';

// The row's "Cumplimiento" divides completed students by the group's
// *enabled* students (usersSlice.studentsPerGroup), so the numerator has
// to be measured the same way: each active student counts at most once,
// however many Progress documents they have for the content (the
// backend's `completed` is a per-student sum over documents, and
// Progress has no unique (course, username) index), and disabled
// students - who are not in the denominator - don't count at all.
// Without this the table could show more than 100%.
export const countCompletedStudents = (
  fulfillments: IFulfillment[],
  activeUsernames: Set<string>
): number => {
  const completedUsernames = new Set<string>();
  fulfillments.forEach(fulfillment => {
    if (fulfillment.completed > 0 && activeUsernames.has(fulfillment.username)) {
      completedUsernames.add(fulfillment.username);
    }
  });
  return completedUsernames.size;
};
